// What kind of change a release note announces, as stored in its `status`. One list for the
// super-admin form, the Release Notes filter and the label on each note. Notes saved before
// Improvement existed may carry Other, which reads as Update.
export const RELEASE_NOTE_TYPES: { value: string, label: string, filterLabel: string }[] = [
  { value: 'Feature', label: 'New feature', filterLabel: 'Features' },
  { value: 'Improvement', label: 'Improvement', filterLabel: 'Improvements' },
  { value: 'Fix', label: 'Fix', filterLabel: 'Fixes' },
  { value: 'Other', label: 'Update', filterLabel: 'Updates' },
]

export const releaseNoteTypeLabel = (status?: string | null): string =>
  RELEASE_NOTE_TYPES.find(type => type.value === status)?.label || status || 'Update'

/** Orders notes released on the same day: new features first, then improvements, then fixes. */
export const releaseNoteTypeRank = (status?: string | null): number => {
  const index = RELEASE_NOTE_TYPES.findIndex(type => type.value === status)
  return index === -1 ? RELEASE_NOTE_TYPES.length : index
}
